// extracted by mini-css-extract-plugin
export default {"container":"IndexDetailsDialog-module__container--V7M3M","header":"IndexDetailsDialog-module__header--BRq28","headerSubtext":"IndexDetailsDialog-module__headerSubtext--EvcXp"};